import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Avatar, IconButton, IconMenu, MenuItem } from 'material-ui';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import AddCircleOutlineIcon from 'material-ui/svg-icons/content/add-circle-outline';
import RecentActorsIcon from 'material-ui/svg-icons/av/recent-actors';
import LiveHelpIcon from 'material-ui/svg-icons/communication/live-help';
import { white, grey400 } from 'material-ui/styles/colors';
import { push as routerPush, replace as routerReplace } from 'react-router-redux';
import injectSheet from 'react-jss';
import { archiveConnection, getConnections } from './store/actions';
import ConnectionListItem from './connection-list-item';
import ConnectionListSearch from './connection-list-search';
import { openModal as openMassDialog } from '../massmessaging/store/actions';
import WallWrapper from '../wall/wrapper';


const styles = {
  connectionsListTitle: {
    alignItems: 'center',
    backgroundColor: 'rgb(0, 161, 186)',
    display: 'flex',
    minHeight: '48px !important',
    justifyContent: 'space-around',
    paddingLeft: '15px !important',
  },
  partnersTitle: {
    color: 'white !important',
    fontSize: '18px',
    flex: '1 1 auto',
    '&.loading': {
      cursor: 'wait',
    },
  },
  connectionRow: {
//    paddingTop: '5px',
    height: '100%',
    overflow: 'auto',
  },
  connectionItem: {
    height: '58px !important',
    color: '#757575 !important', // #00bcd4 < -- selected
    borderLeft: '3px solid transparent !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& .avatarIcon': {
      fill: '#757575 !important',
    },
    '&:hover': {
      backgroundColor: 'transparent !important',
      borderLeft: '3px solid #ff4081 !important',
      color: '#ff4081 !important',
      '&:not(.selected) .avatarIcon': {
        fill: '#ff4081 !important',
      },
    },
    '&.selected': {
      color: '#00bcd4 !important',
      backgroundColor: 'transparent !important',
      borderLeft: '3px solid #00bcd4 !important',
      '& .avatarIcon': {
        fill: '#00bcd4 !important',
      },
    },
    '&.disabled': {
      opacity: '0.3',
    },
  },
  workspaceAvatar: {
    border: 'solid 1px #bbb',
    cursor: 'pointer',
    flex: '0 0 auto',
    left: '0 !important',
    marginLeft: '10px',
    position: 'relative !important',
    top: 'inherit !important',
    '&.unread:after': {
      backgroundColor: '#FF0000',
      borderRadius: '50%',
      content: 'close-quote',
      height: '10px',
      left: '28px',
      top: '30px',
      opacity: '0.8',
      pointerEvents: 'none',
      position: 'absolute',
      width: '10px',
    },
  },
  workspaceMenuItem: {},
  iconMenu: {
    '& > button': {
      padding: '12px 0 12px 0 !important',
      width: '36px !important',
    },
  },
  lastSystemChannel: {
    borderBottom: '1px solid #bbb',
  },
};

class ConnectionList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: '',
    };
  }
  componentDidMount() {
    if (!this.timer) this.timer = setInterval(this.timedUpdate, 6e3);
  }
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  _updateSearch = (searchValue) => {
    this.setState({ searchValue });
  }
  timer = null
  timedUpdate = () => {
    if (!localStorage.stopAutoReload && !this.props.connectionsFetching) this.props.getConnections();
  }
  switchChannel = (connectionId) => {
    if (connectionId === 'inbox') {
      this.props.routerPush(`/workspace/${connectionId}`);
    }
    else this.props.routerPush(`/workspace/${connectionId}/general`);
    const connectionIx = (this.props.connections.map(e => e.id).indexOf(connectionId));
    const lastChannel = this.props.connections[connectionIx].lastChannel;
    if (lastChannel) {
      this.props.routerPush(`/workspace/${connectionId}/${lastChannel}`);
    } else {
      this.props.routerPush(`/workspace/${connectionId}`);
    }
  }
  render() {
    const { connectionsFetching, selectedConnection, connections, classes } = this.props;
    const iconButtonElement = (
      <IconButton touch>
        <MoreVertIcon color={grey400} />
      </IconButton>
    );
    const rightIconMenu = key => (
      <IconMenu iconButtonElement={iconButtonElement} className={classes.iconMenu}>
        <MenuItem className={classes.workspaceMenuItem} onClick={ () => {
          this.props.archiveConnection(key);
        }}
        > Archive
      </MenuItem>
        <MenuItem className={classes.workspaceMenuItem} onClick={ () => {
          window.location = (`${process.env.NEW_SYSTEM_URL}/partner-management/partner-details/${key}?jwt=${localStorage.getItem('jwt')}`);
        }}
        >Partner Details</MenuItem>
      </IconMenu>
    );
    let lastSystemChannel;
    connections.some(e => {
      if (e.archivable) {
        return false;
      }
      lastSystemChannel = e.id;
    });
    return (
        <div className={this.props.className}>
          <div className={`${classes.connectionsListTitle}${connectionsFetching ? ' loading' : ''}`}>
            <div className={classes.partnersTitle}>Channels</div>
            <IconButton iconStyle={{ color: white }} onTouchTap={() => { this.props.openMassDialog(); }}><AddCircleOutlineIcon/></IconButton>
          </div>
        <div className={classes.connectionRow}>
          {[...connections.filter(e => !e.archivable), {
            id: 'search',
            component: connections.filter(e => e.archivable).length > 0 ? <ConnectionListSearch key="id" searchUpdate={this._updateSearch}/> : <span key="nosearch" />,
          }, ...connections.filter(e => {
            return e.archivable && (!this.state.searchValue || new RegExp(`^.*${this.state.searchValue.split(' ').join('.*')}.*$`, 'gi').test(e.name.replace(/ {2}/g, ' ')));
          })]
          // hiding all others for now
          .filter(o => ['bulkmessages', 'inbox'].indexOf(o.id) > -1)
          .map(connection => {
            const newAttributes = {};
            // const iconClassName = (selectedConnection === connection.id ? classes.iconStylesSelected : classes.iconStyles);
            switch (connection.id) {
              case 'bulkmessages':
                newAttributes.icon = <RecentActorsIcon className="avatarIcon"/>;
                newAttributes.avatarText = null;
                break;
              case 'inbox':
                newAttributes.icon = <LiveHelpIcon className="avatarIcon"/>;
                newAttributes.avatarText = null;
                break;
              default:
                if (connection.avatar) {
                  newAttributes.avatarText = null;
                }
                break;
            }
            return ({ ...connection, ...newAttributes });
          }).map(connection => {
            const component = (
              connection.component || <div
                className={`${classes.connectionItem}${connection.disabled ? ' disabled' : ''}${selectedConnection === connection.id ? ' selected' : ''}${lastSystemChannel === connection.id ? ` ${classes.lastSystemChannel}` : ''}`}
                // value={connection.id}
                key={connection.id}
              >
                <Avatar
                  onTouchTap={() => { this.switchChannel(connection.id); }}
                  className={`${classes.workspaceAvatar}${(connection.unread ? ' unread' : '')}`}
                  {...(connection.avatar) ? ({ src: connection.avatar }) : {} }
                  {...(connection.icon) ? ({ icon: connection.icon, style: {
                    backgroundColor: 'none',
                    border: 'none',
                  } }) : {} }
                >
                  {connection.avatarText}
                </Avatar>
                <ConnectionListItem
                  name={connection.name}
                  lastUnread={connection.lastUnread}
                  onTouchTap={() => { this.switchChannel(connection.id); }}
                  noArchive={(connection.archivable !== true)}
                  {...(connection.unread) ? ({ unread: true }) : {}}
                />
                {(connection.archivable) ? rightIconMenu(connection.id) : <div>&nbsp;</div>}
              </div>
            );
            if (connection.id === 'bulkmessages') {
              return (
                <WallWrapper amazonOrange skipClick>
                  {component}
                </WallWrapper>
              );
            }
            return component;
          })}
          </div>
        </div>
    );
  }
}
ConnectionList.propTypes = {
  archiveConnection: PropTypes.func,
  classes: PropTypes.object,
  className: PropTypes.string,
  connections: PropTypes.array,
  connectionsFetching: PropTypes.bool,
  getConnections: PropTypes.func,
  openMassDialog: PropTypes.func,
  routerPush: PropTypes.func,
  routerReplace: PropTypes.func,
  selectedConnection: PropTypes.string,
};


const select = (state) => ({
  connections: state.workspace.connections,
  connectionsFetching: state.workspace.connectionsFetching,
  selectedConnection: state.workspace.selectedConnection,
});

export default connect(select, {
  routerPush,
  routerReplace,
  archiveConnection,
  getConnections,
  openMassDialog,
})(injectSheet(styles)(ConnectionList));



// WEBPACK FOOTER //
// ./src/app/components/workspace/connection-list.jsx